import React from 'react';

import { Banner, Breadcrumbs } from '@/ui/index';
import SvgQuestion from '@/icons/section/Question';
import { Money } from '@/icons/section';

import GeneralServices from '../GeneralServices/GeneralServices';
import Steps from '../Steps/Steps';
import BannerAzer from '../BannerAzer/BannerAzer';
import Questions from '../Questions/Questions';

const RoamingMain = ({ data }) => {
  return (
    <>
      {data?.breadcrumbs && (
        <Breadcrumbs
          data={data.breadcrumbs}
          itemScope
          itemType='http://schema.org/BreadcrumbList'
        />
      )}
      {/* {data?.mainBanner && (
       <Banner />
      )} */}
      <div
        className={'small-margin'}
        itemScope
        itemType='http://schema.org/Service'
      >
        {data?.services && <GeneralServices services={data.services} />}
      </div>
      {data?.steps && (
        <Steps
          data={data.steps}
          Icon={Money}
          itemScope
          itemType='http://schema.org/HowToStep'
        />
      )}
      {data?.banner && (
        <Banner
          item={data.banner}
          href={'/roaming/prices-and-countries'}
          itemScope
          itemType='http://schema.org/CreativeWork'
        />
      )}
      {data?.guestTariff && (
        <BannerAzer
          data={data.guestTariff}
          itemScope
          itemType='http://schema.org/Offer'
        />
      )}
      {data?.questions && (
        <Questions
          questions={data.questions}
          className='wrapper section'
          Icon={SvgQuestion}
          titleModify='title--large'
          itemScope
          itemType='http://schema.org/Question'
        />
      )}
    </>
  );
};

export default RoamingMain;
